import React from 'react';
import { PaginationItem, PaginationRenderItemParams } from '@mui/material';
import { PaginationButton, StyledPagination } from './styles';
import { PaginationProps } from '@/interfaces';

const CustomPrevNextButton: React.FC<PaginationRenderItemParams> = (item) => {
  const text = item.type === 'previous' ? 'Prev' : 'Next';
  return (
    <PaginationButton
      onClick={item.onClick}
      disabled={item.disabled}
    >
      {text}
    </PaginationButton>
  );
};


const CustomPagination: React.FC<PaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange
}) => {

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    onPageChange(value);
  };
  const renderItem = (item: PaginationRenderItemParams) => {
    if (item.type === 'previous' || item.type === 'next') {
      return <CustomPrevNextButton {...item} />;
    }
    return <PaginationItem {...item} />;
  };

  return (
    <StyledPagination
      count={totalPages}
      page={currentPage}
      onChange={handleChange}
      renderItem={renderItem} 
    />
  );
};

export default CustomPagination;